/*jslint node: true*/
"use strict";

var $ = require("pli/jquery");
var ko = require("pli/knockout");

//-------------------------------------------
// Defines a custom knockout binding for tooltip menu.
ko.bindingHandlers.visibleNotification = {
    init: function visibleNotificationInit(element, valueAccessor) {
        var value = valueAccessor(),
            $element = $(element);

        $('html').click(function () { // define an onClick handle on html page
            if (ko.utils.domData.get(element, element.needToCloseOnClickOutside)) {
                value(false);
                ko.utils.domData.set(element, element.needToCloseOnClickOutside, false);
            }
        });

        $element.click(function (event) { // define an onClick handle on the element to prevent global click event
            event.stopPropagation();
        });
    },
    update: function visibleNotificationUpdate(element, valueAccessor) {
        var value = valueAccessor(),
            $element = $(element);
        if (ko.unwrap(value)) {
            $element.show();
            setTimeout(function () { ko.utils.domData.set(element, element.needToCloseOnClickOutside, true); }, 250); // make a delay to prevent hiding the tool tip while it showing by click from tool tip's outside
        } else {
            $element.hide();
        }
    }
};


//-------------------------------------------
module.exports = ko;



//////////////////
// WEBPACK FOOTER
// ./app/ko-visiblenotification/visibleNotification.js
// module id = 531
// module chunks = 49